import { DealerStatistics } from '../../types/statistics';

export const processData = ({
  data
}: {
  data?: Pick<DealerStatistics, 'period'>;
}) => {
  if (!data) return null;
  return data.period.map(({ date, values }) => {
    const total = values.countTotal;
    const rejected = values.countRejected;
    const accepted = values.countAccepted;
    const countSpotSolved = values.countSpotSolved;
    const countSpotNotSolved = values.countSpotNotSolved;

    return {
      date,
      total,
      accepted,
      rejected,
      countSpotSolved,
      countSpotNotSolved
    };
  });
};
